<template>
    <b-card>
        <b-row class="py-4 justify-content-md-center">
            <b-col align-self="end" cols="12" md="auto" class="text-center">
                <div>
                    <b-img :src="imgSrc" />
                </div>
                <div class="font-weight-bold">{{name}}</div>
            </b-col>
        </b-row>
    </b-card>
</template>

<style scoped>
.class1 {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>

<script>
export default {
    props: {
        name: {
            type: String
        },
        imgSrc: {
            type: String
        }
    },
    data() {
        return {

        }
    },
    methods: {

    },
    mounted() {

    }
}
</script>